import React from 'react';
import { FieldLabel } from './FieldLabel';
import './SiparisNotuCard.css';

/**
 * Sipariş notu — vurgulu kart (AP detay / onay; boşsa placeholder).
 */
const SiparisNotuCard = ({ not, className = '' }) => {
  const text = not?.trim() || '';
  const isEmpty = !text;

  return (
    <section
      className={`siparis-notu-card${isEmpty ? ' siparis-notu-card--empty' : ''}${
        className ? ` ${className}` : ''
      }`}
      aria-label="Sipariş notu"
    >
      <div className="siparis-notu-card__head">
        <span className="siparis-notu-card__icon" aria-hidden>
          <i className="fas fa-sticky-note" />
        </span>
        <FieldLabel className="siparis-notu-card__title" as="span">
          Sipariş notu
        </FieldLabel>
      </div>
      <div className="siparis-notu-card__body">
        {isEmpty ? (
          <span className="siparis-notu-card__placeholder">Not girilmedi</span>
        ) : (
          <p className="siparis-notu-card__text">{text}</p>
        )}
      </div>
    </section>
  );
};

export default SiparisNotuCard;
